import React from "react";
import FacultyEventsTable from "./Acitvities/FacultyEventsTable";

// Note: "Course Access" and "Upload Certificate" action buttons are rendered within FacultyEventsTable (commented out)
const FdpCompletion = ({ onDataLoad }) => {
  return <FacultyEventsTable disablePadding onDataLoad={onDataLoad} />;
};

export default FdpCompletion;
